/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_2_DescInputs */

const en_mk_parts_2_desc = /** @type {(inputs: Mk_Parts_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channels, threads, and direct messages. Mention an agent with @ mid-conversation and it answers in the same thread — no app switching.`)
};

const id_mk_parts_2_desc = /** @type {(inputs: Mk_Parts_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel, thread, dan pesan langsung. Sebut agen dengan @ di tengah obrolan dan ia menjawab di thread yang sama — tidak perlu pindah aplikasi.`)
};

/**
* | output |
* | --- |
* | "Channels, threads, and direct messages. Mention an agent with @ mid-conversation and it answers in the same thread — no app switching." |
*
* @param {Mk_Parts_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_2_desc = /** @type {((inputs?: Mk_Parts_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_2_desc(inputs)
	return en_mk_parts_2_desc(inputs)
});